<template>
  <header class="headerNav" :class="[ isFixed ? 'fixed animate__animated animate__slideInDown' : '']">
    <div>
      <div class="mobileHeader" >
        <img src="https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/CEO%20summits/img/mobile/mobileLogo.png" alt="logo" class="logo">
      </div>
    </div> 
  </header>
</template>

<script>
export default {
  name: 'WmtHeader',
  data() {
    return {
      isFixed: false,
      userName: null,
      userInfo: {},
      loginStatus: false,
      logoutShow: false,
      pathName: '/',
      drawer: false,
      direction: 'ltr',
      tilte: ''
    }
  },
  
  methods: {
    // 移动端
   
    
   
  },
  mounted() {
   
  },
  created() {

    
  },
}
</script>

<style lang='less' scoped>
.headerNav {
  width: 100%;
  padding: 10px 28px 0 28px;
  box-sizing: border-box;
  min-height: 70px;
  position: relative;
  // position: fixed;
  // top: 0;
  z-index: 99;
  &.fixed {
    position: fixed;
    top: 0;
    z-index: 199;
    background: #fff;
  }
  .logo {
    width: 265px;
    height: 57px;
  }
  .menu {
    height: 70px;
    line-height: 50px;
    .menuBox {
      display: flex;
      justify-content: right;
    }
    .menuItem {
      font-size: 14px;
      color: #333;
      cursor: pointer;
      text-align: center;
      .active {
        position: relative;
        .active::after {
          content: '';
          background: #2aaed9;
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
          width: 16px;
          height: 4px;
          border-radius: 20px;
          transition: all 0.3s;
        }
      }
    }
    .language {
      font-size: 14px;
      color: rgba(0, 0, 0, 0.2);
      cursor: pointer;
      .check {
        color: #333;
      }
      .line {
        margin: 0 2px;
      }
    }
    .register {
      .regsiterButton {
        width: 60px;
        height: 32px;
        border-radius: 16px;
        border: 1px solid #0ad9b7;
        text-align: center;
        background: transparent;
        line-height: 32px;
        font-size: 14px;
        color: #158d9f;
        margin-right: 10px;
      }
      .login {
        width: 60px;
        height: 32px;
        background: linear-gradient(145deg, #0ad9b7 0%, #1e4889 100%);
        border-radius: 16px;
        text-align: center;
        line-height: 32px;
        border: none;
        font-size: 14px;
        color: #ffffff;
      }
    }
    .userName {
      position: relative;
      .userName:hover {
        .slides {
          display: block;
        }
      }
      .slides {
        display: none;
        position: absolute;
        bottom: -80px;
        background: #fff;
        color: #1e2330;
        word-break: keep-all;
        line-height: 40px;
        width: 132px;
        text-align: center;
        box-shadow: 0 1px 15px 0 rgba(30, 36, 49, 0.15);
        border-radius: 4px;
        cursor: pointer;
        z-index: 99;
        li {
          width: 100%;
          text-align: center;
        }
      }
    }
  }
}

.mobileHeader {
  display: flex;
  justify-content: center;
  width: 100%;
  // min-height: 88px;
  .menuIcon {
    font-size: 20px;
    color: #333;
  }
  .logo {

    width: 178px;
    height: 38px;
  }
  .userInfo {
    font-size: 20px;
    color: #333;
  }
}
.mMenu {
  padding: 14px;
  box-sizing: border-box;
  .mMenuItem {
    margin-bottom: 30px;
    font-size: 14px;
    color: #333;
  }
}
</style>


<style lang='less'>
.headerNav{
  .el-drawer__wrapper{
    height: 100vh;
  }
  .v-modal{
    height: 100vh;
  }
}
.el-drawer {
  width: 60% !important;
  z-index: 99999999;
}
</style>